module.exports = "/images/mainProfile.svg";